<template>
	<div class="fondoModal">
		<div>
			<div style="max-width:600px;">
				<div class="card">
					<div class="card-header">
						Historial de la tarea
						<button type="button" class="close" aria-label="Close" @click="cerrar">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<table class="table m-0 text-left">
						<thead>
							<tr>
								<th colspan="2">Usuario</th>
								<th>Fase</th>
								<th>Fecha</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="fase in fases" :key="fase.ID_cambio" :class="getClase(fase.fase)">
								<td style="width:40px;">
									<img v-if="fase.usuario" :src="fase.usuario.avatar" alt="avatar" class="rounded-circle" style="width:40px;height:auto;">
								</td>
								<td style="vertical-align:middle;">
									<span v-if="fase.usuario">{{fase.usuario.nombre}}</span>
								</td>
								<td style="vertical-align:middle;">
									{{getAccion(fase.fase)}}
								</td>
								<td style="vertical-align:middle;">
									{{diaSem[fase.fecha.getDay()]}}, {{fase.fecha.toLocaleDateString()}}<br>
									a las {{fase.fecha.toLocaleTimeString()}}
								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>


<script>
import API from '../../services/api'

export default {
	name: 'historial',
	props: ['idtarea'],
	data: function () {
		return {
			fases: [],
			diaSem: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sáb']
		}
	},

	created () {
		// Descargamos el historial de esta tarea
		this.getHistorial()
	},

	methods: {
		getHistorial () {
			API.getHistorial(this.idtarea)
				.then(res => {
					const historial = res.data.historial
					for (let i = 0; i < historial.length; i++) {
						historial[i].fecha = new Date(historial[i].fecha)
					}
					this.fases = historial
				})
				.catch(e => {
					this.$store.commit('alertas/alert', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},

		getAccion (fase) {
			switch (fase) {
			case 'creada':
				return 'Versión creada'
			case 'pteIdea':
				return 'Pendiente de creatividad'
			case 'pteAprobarIdea':
				return 'Pendiente de aprobar idea creativa'
			case 'pteProduccion':
				return 'Pendiente de producción'
			case 'pteAprobarProduccion':
				return 'Pendiente de aprobar producción'
			case 'finalizada':
				return 'Tarea finalizada'
			case 'rechazada':
				return 'Versión rechazada'
			default:
				return 'Fase no reconocida'
			}
		},

		getClase (fase) {
			switch (fase) {
			case 'creada':
				return 'bg-info text-white'
			case 'pteIdea':
				return 'bg-light'
			case 'pteAprobarIdea':
				return 'bg-warning'
			case 'pteProduccion':
				return 'bg-light'
			case 'pteAprobarProduccion':
				return 'bg-warning'
			case 'finalizada':
				return 'bg-success'
			case 'rechazada':
				return 'bg-danger text-white'
			default:
				return 'Fase no reconocida'
			}
		},

		getIcono (fase) {
			switch (fase) {
			case 'creada':
				return 'fa fa-new'
			case 'pteIdea':
				return 'fa fa-light'
			case 'pteAprobarIdea':
				return 'fa fa-check'
			case 'pteProduccion':
				return 'fa fa-gear'
			case 'pteAprobarProduccion':
				return 'fa fa-check'
			case 'finalizada':
				return 'fa fa-finish'
			case 'rechazada':
				return 'fa fa-ban'
			default:
				return 'fa fa-question'
			}
		},

		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/modulos/produccion/vue/components/produccion/historial.vue